import React from 'react'

import { Image } from '@application/Interfaces/Atoms/Image'
import { Tilt } from '@application/Interfaces/Atoms/Tilt'
import { useTranslation } from '@application/Interfaces/Hooks/useTranslation'
import { CalendarIcon } from '@application/Interfaces/Icons'
import { BlogCardType } from '@application/Types/ComponentTypes'
import { getMaxCharacter } from '@application/Utils/StringUtility'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import { Link } from '@src/Application/Interfaces/Atoms/Link'
import { ThemeModeType } from '@src/Application/Types/ComponentTypes'

import { Description, ImageWrapper, Title, TitleLink, Wrapper } from './BlogCard.styled'

export const BlogCard = ({
    item,
    mode,
    titleTag = 'h3',
}: {
    item: BlogCardType
    mode: ThemeModeType
    titleTag?: 'h2' | 'h3'
}): JSX.Element => {
    const { t } = useTranslation()

    const WrapperTilt = item.imageAnimation ? Tilt : React.Fragment

    return (
        <Wrapper $mode={mode}>
            {item.image && (
                <Link to={item.link}>
                    <WrapperTilt>
                        <ImageWrapper>
                            <Image image={item.image} />
                        </ImageWrapper>
                    </WrapperTilt>
                </Link>
            )}
            <Grid container spacingTop={3} spacingBottom={3}>
                <Grid item xs={6}>
                    {t(item.category)}
                </Grid>
                {item.date && (
                    <Grid item container xs={6} alignItems="center" justifyContent="right">
                        <CalendarIcon />
                        {item.date}
                    </Grid>
                )}
            </Grid>

            <TitleLink to={item.link}>
                <Title as={titleTag}>{item.title}</Title>
            </TitleLink>
            {item.description && (
                <TitleLink to={item.link}>
                    <Description title={item.description}>{getMaxCharacter(item.description)}</Description>
                </TitleLink>
            )}
        </Wrapper>
    )
}
